import { CourseActions } from 'actions';
import File from 'components/File';
import { GridCell, GridRow } from 'components/Grid';
import Embed from 'components/Page/Module/Embed';
import FileUpload from 'components/Widgets/FileUpload';
import { Units } from 'Css';
import { LinearProgress, RaisedButton, TextField } from 'material-ui';
import { translate as _l } from 'oxygen-i18n';
import React, { Component, PropTypes } from 'react';
import Message from 'services/Message';
import styles from './Styles';
import TaskResultList from './TaskResultList';
import TextTaskResult from './TextTaskResult';
import DialogPortal from 'components/DialogPortal';
import { Dialog } from 'material-ui';

const css = oxygenCss({
  fileContainer: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  file: {
    flexGrow: 0,
    flexShrink: 0,
    margin: Units.base,
    position: 'relative'
  },
  comment: {
    marginLeft: '10px',
    background: '#fff0cb',
    padding: '5px 10px',
    width: 'calc(100% - 40px)'
  }
});

const hasUnCorrectedTasks = results => {
  let uncorrectedCount = 0;
  if(!!results){
    for (let i = 0; i < results.length; i++) {
      const element = results[i];
      if (
        element &&
        element.feedback &&
        !element.feedback.created &&
        typeof element.feedback.created_by !== 'number'
      ) {
        uncorrectedCount++;
      }
    }
  }
  return uncorrectedCount;
};

const style = {
  removeButton: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0
  }
};

export default class TextTask extends Component {
  constructor(props) {
    super(props);
    this.uncorrected = hasUnCorrectedTasks(props.taskResults);
    this.state = {
      open: false,
      progress: 0,
      direction: null,
      files: []
    };
  }

  static contextTypes = {
    getIntlMessage: PropTypes.func
  };

  toggleOpen = () => {
    this.setState(state => ({ open: !state.open }));
  };

  answer = () => {
    let answerValue = this.refs.answer.getValue();
    const { pageModuleId, taskId, id } = this.props;

    CourseActions.answerTask(
      taskId || id,
      pageModuleId,
      {
        value: [
          answerValue +
          this.state.files.map(file => `[file:${file.id}]`).join('')
        ]
      },
      this.state.files
    );
    Message.info(this.context.getIntlMessage('tasks.answerSent'));
    this.refs.answer.clearValue();
    this.setState({ files: [] });
    this.props.gaTracking && this.props.gaTracking();
  }

  progress(e) {
    this.setState({ progress: e.percent, direction: e.direction });
  }

  attach(uploadedFiles) {
    for (let i = 0; i < uploadedFiles.length; i++) {
      for (let k = 0; k < this.state.files.length; k++) {
        if (uploadedFiles[i].file.id === this.state.files[k].id) {
          return;
        }
      }
    }
    if (uploadedFiles.length > 0) {
      const files = [
        ...this.state.files,
        ...uploadedFiles.map(file => file.file)
      ];

      this.refs.fileUploadedDialog.show();
      this.setState({ files });
    }
  }

  removeFile = index => {
    const files = [...this.state.files];
    files.splice(index, 1);
    this.setState({ files });
  };

  renderAnswerControls() {
    const { themeColor } = this.props;
    let fileComponent, uploadProgress;
    const { progress, direction, files } = this.state;
    const uploading = direction === 'download' && progress > 0 && progress < 100;
    fileComponent = (
      <div className={css.fileContainer}>
        {files.map((file, index) => {
          return (
            <div key={index} className={css.file}>
              <File url={file.url} caption={file.name} />
              <RaisedButton
                label={this.context.getIntlMessage('Remove')}
                fullWidth
                style={style.removeButton}
                onTouchTap={() => this.removeFile(index)}
              />
            </div>
          );
        })}
      </div>
    );
    if (uploading) {
      uploadProgress = (
        <div style={styles.progress}>
          <LinearProgress mode="determinate" value={progress} />
        </div>
      );
    }
    return (
      <div style={styles.answerControls}>
        <TextField
          ref="answer"
          floatingLabelText={this.context.getIntlMessage('tasks.answer')}
          hintText={this.context.getIntlMessage('tasks.provideAnswer')}
          fullWidth={true}
          multiLine={true}
        />
        {fileComponent}
        {uploadProgress}
        <GridRow fluid={true}>
          <GridCell size={6}>
            <div style={styles.answer.button}>
              <RaisedButton
                disabled={uploading}
                onTouchTap={this.answer}
                fullWidth
                backgroundColor={themeColor}
                labelColor="#FFF"
                label={this.context.getIntlMessage('tasks.answerOpenEnded')}
              />
            </div>
          </GridCell>
          <GridCell size={6}>
            <div style={styles.upload.button}>
              <FileUpload
                disabled={uploading}
                multiple={true}
                fullWidth={true}
                onProgress={this.progress.bind(this)}
                onSuccess={this.attach.bind(this)}
                label={this.context.getIntlMessage('attachFile')}
              />
            </div>
          </GridCell>
        </GridRow>
      </div>
    );
  }

  renderDialog() {
    return (
      <DialogPortal>
        <Dialog
          ref="fileUploadedDialog"
          autoDetectWindowHeight={true}
          autoScrollBodyContent={true}
          dismissOnClickAway={true}
        >
          {this.context.getIntlMessage('tasks.fileUploaded')}
        </Dialog>
      </DialogPortal>
    )
  }

  render() {
    let {
      caption,
      canAnswer,
      taskResults,
      correctResponse,
      canGrade,
      file,
      captionFiles,
      reader,
      taskMode
    } = this.props;
    let answerControls;
    if (canAnswer) {
      answerControls = this.renderAnswerControls();
    }
    let external = null;
    try {
      external = JSON.parse(
        (this.props.frontend && this.props.frontend[0]) || null
      );
    } catch (err) { }
    let fileType = null;
    let File = file
      ? file
      : external
        ? { ...external, type: 'external' }
        : captionFiles && captionFiles[0];
    let ext;
    if (File && File.type.includes('image')) {
      ext = File.type.replace(/\/(jpeg|jpg|png|webp)/g, '');
    } else if (File && File.type.includes('video')) {
      ext = File.type.replace(/\/(mp4)/g, '');
    } else if (File && File.type.includes('audio')) {
      ext = File.type.replace(/\/(mp4|x-m4a)/g, '');
    } else if (File && File.type === 'external') {
      ext = 'external';
    }
    switch (ext) {
      case 'video':
        fileType = (
          <video style={{ width: '100%' }} controls alt={File.name}>
            <source
              src={File.url.includes('.mp4') ? File.url : File.url + '.mp4'}
              type={File.type}
            />
          </video>
        );
        break;

      case 'image':
        fileType = (
          <img style={{ width: '100%' }} src={File.url} alt={File.name} />
        );
        break;

      case 'audio':
        fileType = (
          <audio controls style={{ width: '100%' }}>
            <source src={File.url} type={File.type} />
          </audio>
        );
        break;

      case 'external':
        fileType = <Embed provider={File.provider} id={File.id} />;
        break;

      default:
        break;
    }

    const results = taskResults && taskResults.sort((a, b) => {
      const A =
        a &&
        a.feedback &&
        !a.feedback.created &&
        typeof a.feedback.created_by !== 'number';
      const B =
        b &&
        b.feedback &&
        !b.feedback.created &&
        typeof b.feedback.created_by !== 'number';
      if (!A && B) {
        return 1;
      } else if (A && !B) {
        return -1;
      } else {
        return 0;
      }
    }) || [];

    return (
      <div style={styles.container}>
        {File && fileType}
        <div
          onClick={this.toggleOpen}
          style={{
            ...styles.question,
            cursor: results.length > 0 && 'pointer',
            opacity: taskMode && results.length === 0 && this.uncorrected < 1 && 0.5,
          }}
        >
          {!!this.uncorrected && <p style={styles.uncorrected}>{this.uncorrected}</p>} {caption.main}
        </div>
        {answerControls}
        {(!taskMode || this.state.open) && (
          <TaskResultList
            reader={reader}
            canGrade={canGrade}
            taskId={this.props.id}
            correctResponse={correctResponse}
            ListElement={TextTaskResult}
            results={results}
          />
        )}
        {caption &&
          caption.comment &&
          taskResults &&
          taskResults[taskResults.length - 1] &&
          !!diff(
            taskResults[taskResults.length - 1].body.value,
            correctResponse.value
          ).length && (
            <div className={css.comment}>
              <h5>{_l`comment`}</h5>
              <i>{caption.comment}</i>
            </div>
          )}
          { this.renderDialog() }
      </div>
    );
  }
}

function diff(a, b) {
  return b.filter(i => {
    return a.indexOf(i) < 0;
  });
}



// WEBPACK FOOTER //
// ./src/js/components/Route/Task/TextTask.js